<template>
  <v-select
    :item-text="itemText"
    :item-value="itemValue"
    :items="items"
    :label="label"
    :rules="rules"
    :value="value"
    :hint="hint"
    :name="name"
    :disabled="loading"
    :loading="loading"
    :append-icon="null"
    :clearable="clearable"
    :search-input.sync="search"
    :return-object="returnObject"
    :class="['select', {'select--no-margin': noMargin}]"
    persistent-hint
    :menu-props="{contentClass:'select-content'}"
    validate-on-blur
    @input="onInput"
  ></v-select>
</template>

<script>
import debounce from "lodash/debounce";
import Typography from "@/components/Typography.vue";
import LoadingCircle from "@/components/LoadingCircle.vue";

export default {
  components: {
    Typography,
    LoadingCircle
  },
  props: {
    itemText: {
      type: String,
      default: "text"
    },
    itemValue: {
      type: String,
      default: "value"
    },
    textValue: {
      type: String,
      default: ""
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    hideNoData: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    noDataText: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: null
    },
    troubleText: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Array,
      default: () => []
    },
    value: {
      type: null,
      default: ""
    },
    hint: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    search: {
      get() {
        return this.value;
      },
      set(newVal) {
        if (newVal === "") {
          // Clear selected business when manually clearing input
          this.$emit("input", null);
        }
        // Update text input value
        this.$emit("text-input", newVal);
        if (newVal && newVal !== this.textValue) {
          this.debouncedOnSearch(newVal);
          }
      }
    }
  },
  created() {
    this.debouncedOnSearch = debounce(this.onSearch, 500);
  },
  methods: {
    onInput(value) {
      // When item is clicked from dropdown
      // First update the text input
      if (this.returnObject) {
        this.$emit("text-input", value[this.itemValue]);
      } else {
        this.$emit("text-input", value);
      }

      // Then update the object input
      this.$emit("input", value);
    },
    onSearch(value) {
      this.$emit("search", value);
    },
    onManualInputClick() {
      this.$emit("manual");
    },
    onBlur() {
      this.$emit("blur");
    }
  }
};
</script>

<style lang="less">
@import "../assets/styles/_responsive.less";
@import "../assets/styles/_variables.less";

.v-select {
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 25px;
  color: @charcoal !important;

  &--no-margin {
    margin-bottom: 0;
  }

  /* TODO: why doesn't this work? */
  /deep/ .v-input__slot {
    &:before {
      border-width: 2px 0 0 !important;
    }
  }

  .v-messages {
    font-size: 15px;
    color: @mid-charcoal !important;

    &.error--text {
      color: @error-color !important;
    }
  }

  .v-input__slot {
    &:after {
      color: currentColor;
      border-width: 2px;
    }

    &:before {
      border-color: @mid-charcoal !important;
      border-width: 2px;
    }

    &:hover {
      &:before {
        border-color: @charcoal !important;
      }
    }
  }

  &.error--text {
    color: @error-color !important;

    .v-input__slot {
      &:before {
        border-color: @error-color !important;
      }

      &:after {
        color: @error-color !important;
      }
    }
  }

  .v-label {
    font-size: 20px;

    &--active {
      transform: translateY(-18px) scale(0.6);
      font-weight: @weight-medium;
    }
  }
}
</style>
